import React from 'react';
import { observer } from 'mobx-react';
import Chip from '@material-ui/core/Chip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Panel from '../../commons/Panel';
import EvolucaoDialog from '../../commons/EvolucaoDialog';

import AuthenticationStore from '../../../stores/AuthenticationStore';
import EvolucaoStore from '../../../stores/EvolucaoStore';
import SelecaoStore from '../../../stores/SelecaoStore';
import UIStore from '../../../stores/UIStore';

class Projecao extends React.Component {
  componentWillMount() {
    UIStore.init('Projeção de Votos', null, null, false, () =>
      SelecaoStore.loadCandidatos('PROJETADO')
    );
    SelecaoStore.loadCandidatos('PROJETADO');
  }

  render() {
    let candidatos = SelecaoStore.candidatos
      .slice()
      .sort(
        (c1, c2) =>
          (!c2.candidato ? -100.0 : c2.media) -
          (!c1.candidato ? -100.0 : c1.media)
      );
    return (
      <React.Fragment>
        <Panel
          title="Projeção de Votos"
          loadHistory={() =>
            EvolucaoStore.loadCandidatosMajoritarios('PROJETADO')
          }
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Respostas</TableCell>
                <TableCell numeric>Projeção</TableCell>
                <TableCell numeric>(%)</TableCell>
                <TableCell numeric>Válidos</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {candidatos.map(c => (
                <TableRow key={c.id}>
                  <TableCell>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        height: '40px',
                        verticalAlign: 'middle',
                        lineHeight: '40px',
                      }}
                    >
                      {c.candidato
                        ? c.candidato.nome
                        : c.tipo === 'NAO_VOTARA'
                          ? 'Abstenções'
                          : 'Brancos/Nulos'}

                      {c.candidato ? (
                        <Chip
                          label={c.candidato.partido.sigla}
                          style={{
                            backgroundColor: c.candidato.partido.cor,
                            fontWeight: 'bold',
                            color: 'white',
                          }}
                        />
                      ) : (
                        ''
                      )}
                    </div>
                  </TableCell>
                  <TableCell numeric>
                    {c.projecao ? c.projecao.formatInteger() : '---'}
                  </TableCell>
                  <TableCell numeric>
                    {c.media ? c.media.formatPercent() : '---'}
                  </TableCell>
                  <TableCell numeric>
                    {c.valido ? c.valido.formatPercent() : '---'}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                    height: '40px',
                    verticalAlign: 'middle',
                    lineHeight: '40px',
                  }}
                >
                  Total
                </TableCell>
                <TableCell numeric>
                  {AuthenticationStore.me.pesquisa.eleitores.formatInteger()}
                </TableCell>
                <TableCell numeric>100%</TableCell>
                <TableCell numeric>---</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Panel>
        <EvolucaoDialog
          title="Evolução do Candidato"
          opened={EvolucaoStore.candidatos != null}
          data={EvolucaoStore.candidatos}
          onOK={() => (EvolucaoStore.candidatos = null)}
          columnFunc={col =>
            col === 'NAO_VOTARA'
              ? 'Abstenções'
              : col === 'INDECISO'
                ? 'Indecisos'
                : col === 'BRANCO'
                  ? 'Brancos/Nulos'
                  : col
          }
        />
      </React.Fragment>
    );
  }
}

export default observer(Projecao);



// WEBPACK FOOTER //
// ./src/components/majoritario/projecao/index.js